module.exports = __webpack_public_path__ + "img/logo-m.53244425.svg";